import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/contexts/auth'
import { rememberPostLoginPath } from '@/lib/utils'
import { LoadingSpinner } from './LoadingSpinner'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-background">
        <LoadingSpinner size="lg" />
        <p className="mt-4 text-muted-foreground">Loading your library...</p>
      </div>
    )
  }

  if (!user) {
    // Deep links (e.g. club invites) survive the login round-trip
    if (location.pathname !== '/dashboard') {
      rememberPostLoginPath(location.pathname + location.search)
      return <Navigate to="/login" replace />
    }
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
